import { render, staticRenderFns } from "./attribute-and-personality.vue?vue&type=template&id=43c979ee"
var script = {}
import style0 from "./attribute-and-personality.vue?vue&type=style&index=0&id=43c979ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports